import { Inject, Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { get, identity } from 'lodash';

import {
  buildFields,
  FLEXIBLE_FORMS_CONFIG,
  FlexibleFormFieldsDefinition,
  FlexibleFormFieldsVariants,
  FlexibleFormInitializers,
  FlexibleFormParsers,
  FlexibleFormsConfig,
} from './flexible-form';

@Injectable()
export class FlexibleFormsBuilder {
  definition!: FlexibleFormFieldsDefinition;

  variants!: FlexibleFormFieldsVariants;

  initializers!: FlexibleFormInitializers;

  parsers!: FlexibleFormParsers;

  constructor(
    @Inject(FLEXIBLE_FORMS_CONFIG) fieldsDefinition: FlexibleFormsConfig
  ) {
    this.definition = fieldsDefinition.definition;
    this.variants = fieldsDefinition.variants;
    this.initializers = fieldsDefinition.initializers || { DEFAULT: identity };
    this.parsers = fieldsDefinition.parsers || { DEFAULT: identity };
  }

  buildFields(
    key: 'DEFAULT' | number | string = 'DEFAULT',
    model: unknown = {}
  ): FormlyFieldConfig[] {
    const fields = this.getFields(key);
    return this._buildFields(fields, model);
  }

  getFields(key: string | number): FormlyFieldConfig[] {
    return get(this.variants, key) || this.variants.DEFAULT;
  }

  initializeModel(
    model: any,
    data: any = {},
    key: 'DEFAULT' | number = 'DEFAULT'
  ) {
    return this.getInitializers(key)(model, data);
  }

  getInitializers(key: 'DEFAULT' | number) {
    return get(this.initializers, key) || this.initializers.DEFAULT;
  }

  parseModel(model: any, key: 'DEFAULT' | number = 'DEFAULT') {
    return this.getParsers(key)(model);
  }

  private getParsers(key: 'DEFAULT' | number) {
    return get(this.parsers, key) || this.parsers.DEFAULT;
  }

  private _buildFields(
    fields: FormlyFieldConfig[],
    model: unknown
  ): FormlyFieldConfig[] {
    return buildFields(this.definition, fields, model);
  }
}
